import { schemaTransactionSign, schemaTransactionSignAndBroadcast, serializeTransaction, } from "@ledgerhq/wallet-api-core";
export class TransactionModule {
    client;
    constructor(client) {
        this.client = client;
    }
    /**
     * Let the user sign a transaction that won't be broadcasted by the connected wallet
     * @param accountId - id of the account
     * @param transaction - The transaction object in the currency family-specific format
     * @param options - Extra parameters
     *
     * @returns The raw signed transaction
     * @throws {@link RpcError} if an error occured on server side
     */
    async sign(accountId, transaction, options, meta) {
        const transactionSignResult = await this.client.request("transaction.sign", {
            accountId,
            rawTransaction: serializeTransaction(transaction),
            options,
            meta,
        });
        const safeResults = schemaTransactionSign.result.parse(transactionSignResult);
        return Buffer.from(safeResults.signedTransactionHex, "hex");
    }
    /**
     * Let the user sign and broadcast a transaction
     * @param accountId - id of the account
     * @param transaction - The transaction object in the currency family-specific format
     * @param options - Extra parameters
     *
     * @returns The transaction hash
     * @throws {@link RpcError} if an error occured on server side
     */
    async signAndBroadcast(accountId, transaction, options, meta) {
        const transactionSignResult = await this.client.request("transaction.signAndBroadcast", {
            accountId,
            rawTransaction: serializeTransaction(transaction),
            options,
            meta,
        });
        const safeResults = schemaTransactionSignAndBroadcast.result.parse(transactionSignResult);
        return safeResults.transactionHash;
    }
}
//# sourceMappingURL=Transaction.js.map